module.exports = __webpack_public_path__ + "img/MC-Logo-Web-Color-StackedTagline.213fdb3.png";